import { User } from "@/types/apiTypes";
import { createContext, useContext } from "react";

interface myFetchData {
  data?: User;
  isError: boolean;
  isLoading: boolean;
  onCancel?: () => void;
  actionDisabled?: boolean;
  onConfirm?: () => void;
}

export const MyDataContext = createContext<myFetchData | null>(null);

export const useMyDataContext = () => {
  const context = useContext(MyDataContext);
  if (!context) {
    throw new Error("useMyDataContext must be used within a MyDataProvider");
  }
  return context;
};
